import { Buyer, Client, ClientContract, Material, SortingCenter, SortingCenterContract, Stream } from 'types';
import { filterUniqueElementsInArrayOfObjects } from './array';

export const formatSortingCenterAddressForDashboard = (sortingCenter: SortingCenter | null): string => {
  if (!sortingCenter) return '-';
  if (!sortingCenter.addressLine || !sortingCenter.postalCode || !sortingCenter.city) return '-';
  return `${sortingCenter.addressLine}\n${sortingCenter.postalCode} ${sortingCenter.city}`;
};

export const getMaterialsFromClientContracts = (contracts: ClientContract[] | null): Material[] => {
  if (!contracts) {
    return [];
  }

  const materials = contracts.map((contract: ClientContract) => contract.material);

  return filterUniqueElementsInArrayOfObjects(materials);
};

export const getBuyersFromMaterialWithClientContracts = (
  materialId: string | undefined | null,
  contracts: ClientContract[] | null,
): Buyer[] => {
  if (!materialId || !contracts) {
    return [];
  }
  const filteredContracts = contracts.filter((contract: ClientContract) => materialId === contract.material['@id']);

  const buyers = filteredContracts.map((contract: ClientContract) => contract.buyer);

  return filterUniqueElementsInArrayOfObjects(buyers);
};

export const getClientsForGivenBuyerAndMaterialFromContracts = (
  materialId: string | undefined | null,
  buyerId: string | undefined | null,
  contracts: ClientContract[] | null,
): Client[] => {
  if (!materialId || !buyerId || !contracts) {
    return [];
  }
  // Filter out contracts that are out of date?
  const filteredContracts = contracts.filter(
    (contract: ClientContract) => materialId === contract.material['@id'] && buyerId === contract.buyer['@id'],
  );
  const clients = filteredContracts.map((contract: ClientContract) => contract.client);
  return filterUniqueElementsInArrayOfObjects(clients);
};

export const getClientsFromActiveContracts = (contracts: SortingCenterContract[] | null): Client[] => {
  if (!contracts) {
    return [];
  }

  const clients = contracts.map((contract: SortingCenterContract) => contract.client);

  return filterUniqueElementsInArrayOfObjects(clients);
};

export const getStreamsFromClientAndActiveContracts = (
  clientId: string | undefined | null,
  contracts: SortingCenterContract[] | null,
): Stream[] => {
  if (!clientId || !contracts) {
    return [];
  }
  const filteredContracts = contracts.filter((contract: SortingCenterContract) => clientId === contract.client['@id']);
  const streams = filteredContracts.map((contract: SortingCenterContract) => contract.stream);

  return filterUniqueElementsInArrayOfObjects(streams);
};
